<!-- Content and Footer -->
<div
	[copoScroller]="{ restoreAfterViewInit: false }"
	#scroller="copoScroller"
	class="sidenav-content"
	@routeAnimation
>
	<copo-panel-header
		[isBackButtonVisible]="isButtonPreviousVisible()"
		(backButtonClick)="goToBackView()"
		[titleHeaderText]="pageTitle"
		[pathHeaderText]="getPathHeader()"
	>
		<button type="button" mat-flat-button 
			*ngIf="getCurrentStatus()"
			(click)="evtSaveOffer()"
			[disabled]="readOnlyUser">
			<span translate>eoffer.save.offer.draft</span>
			<mat-icon iconPositionEnd class="save-icon" svgIcon="action_save"></mat-icon>
		</button>

		<button *ngIf="!isLoading && isButtonViewCardVisible()" type="submit" mat-flat-button color="primary"
				(click)="goNextStep()">
			<span translate>action.viewcart</span>
			<span *ngIf="getProductCount() > 0">&nbsp;({{getProductCount()}})</span>
		</button> 
		
		<button *ngIf="!isLoading && isButtonNextVisible()" type="submit" mat-flat-button color="primary"
			(click)="goNextStep()">
			<span translate>global.next</span>
		</button>

		<button class="submit-btn" *ngIf="!isLoading && isButtonSubmitVisible()" type="submit" mat-flat-button color="primary"
				[disabled]="readOnlyUser">
			<span translate>eoffer.wizard.submit</span>
		</button>

	</copo-panel-header>
	<div class="copo-wizzard-stepper-container">
		<copo-offer-wizard-stepper></copo-offer-wizard-stepper>

		<ng-template #loading>
			<copo-loading-spinner></copo-loading-spinner>
		</ng-template>

		<router-outlet
			*ngIf="!isLoading; else loading"
			(activate)="onActivate($event)"
			(deactivate)="onDeactivate()"
			copoAfterViewInit
			(afterviewinit)="scroller.restoreState()"
		></router-outlet>

		
	</div>
</div>
